import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { CountryBO } from '@skylab-shared/business';
import { EventBusBase } from '@skylab-shared/core';
import { CountryModel } from '@skylab-shared/dataModel';

import { CountryRepository, CountryRepositoryBase } from '@skylab-angular-shared/business';
import { CommandBus, EventBus, L10n, L10nBase, RootContext, RootContextBase, Weaver, WeaverBase } from '@skylab-angular-shared/core';
import { BooleanValueAccessorDirective, ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, FocusByDirective, FormContainerComponent, TextValueAccessorDirective, ToastService, ValidateDirective, ValidationSourceDirective } from '@skylab-angular-shared/ui';

import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DictionaryDialogComponentBase, DictionaryDialogViewModelBase } from '../dictionary-dialog-base';

export interface CountryDialogResult {
    id: number;
    version: string;
}

interface CountryViewModel extends DictionaryDialogViewModelBase<CountryBO> {}
@Component({
    selector: 'skl-country-dialog',
    templateUrl: './country-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, ValidationSourceDirective, BooleanValueAccessorDirective, FormsModule, ValidateDirective, TextValueAccessorDirective, FocusByDirective, ButtonComponent, TranslatePipe]
})
export class CountryDialogComponent extends DictionaryDialogComponentBase
<
CountryModel,
CountryBO,
CountryRepositoryBase,
CountryViewModel
> {
    public constructor(
        @Inject(CountryRepository) CountryRepository: CountryRepositoryBase,
        @Inject(RootContext) rootContext: RootContextBase,
        @Inject(Weaver) weaver: WeaverBase,
        @Inject(L10n) l10n: L10nBase,
        @Inject(EventBus) eventBus: EventBusBase,
        toastService: ToastService,
        commandBus: CommandBus,
        dialogService: DialogInsService
    ) {
        super(CountryRepository, toastService, l10n, weaver, rootContext, commandBus, eventBus, dialogService);
    }
}
